import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import WhyChoose from "../components/WhyChoose";
import Properties from "../components/Properties";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { Toaster } from "../components/ui/toaster";
import { ValuationProvider } from "../components/ValuationDialog";
import Seo from "../components/Seo";

function HomeContent() {
  const location = useLocation();
  useEffect(() => {
    const id = location.state?.scrollTo;
    if (id) {
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - 70;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 300);
    }
  }, [location.state]);

  return (
    <div className="App">
      <Seo title="New Space | Letting & Management Agents in Hackney, London" description="Independent, boutique lettings and property management specialist in Hackney. Excellent value, reliable management and a single senior point of contact for landlords across East & North London." path="/" />
      <Header />
      <Hero />
      <About />
      <WhyChoose />
      <Properties />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default function Home() {
  return (
    <ValuationProvider>
      <HomeContent />
    </ValuationProvider>
  );
}
